interface FeedbackQuestionData {
  id?: number;
  title?: string;
  help?: string;
  type?: string;
}
export class FeedbackQuestion {
  public static readonly TYPE_BOOL: string = 'bool';
  public static readonly TYPE_HURT: string = 'hurt';
  public static readonly TYPE_BORG: string = 'borg';
  public static readonly TYPE_REMARK: string = 'remark';

  public static getNonTranslatableFields(): string[] { return ['id', 'type']; }
  public static getTranslatableFields(): string[] { return ['title', 'help']; }
  public static getFields(): string[] { return ['id', 'title', 'help', 'type']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  title?: string;
  help?: string;
  type?: string;

  public static fromAPI(data: FeedbackQuestionData, translationsData: any[]): FeedbackQuestion {
    let translationData: any = {};
    for (let i = 0; i < translationsData.length; i++) {
      if (translationsData[i]['feedbackQuestionId'] === data['id']) {
        translationData = translationsData[i];
        i = translationsData.length;
      }
    }
    return new FeedbackQuestion({
      id: data.id,
      title: translationData.title ?? data.title,
      help: translationData.help ?? data.help,
      type: data.type
    });
  }
  public static fromAPIList(data: FeedbackQuestionData[], translationsData: any[]): FeedbackQuestion[] {
    return data.map((item) => FeedbackQuestion.fromAPI(item, translationsData));
  }

  constructor({ id, title, help, type }: FeedbackQuestionData) {
    this.id = id;
    this.title = title;
    this.help = help;
    this.type = type;
  }

  public toJson(): FeedbackQuestionData {
    return {
      id: this.id,
      title: this.title,
      help: this.help,
      type: this.type
    };
  }
}
